@if (updateAvailable()) {
    <button vds-button appearance="secondary" mode="dark" (click)="updateAndRestart()">{{ "updateAndRefresh" | transloco }}</button>
}
